import type { BulkAction } from './bulk_action';

import { standardRequest } from 'shared/utils/request';

export async function fetchBulkActions(
  path: string
): Promise<Array<BulkAction>> {
  const response = await standardRequest(path);

  return response.data;
}
